
import React from 'react';
export const Rules = [
  
  {
    title: 'c1_title',
    items: [
      "c1_text1",
      "c1_text2",
      "c1_text3",
      "c1_text4",
      "c1_text5",
      "c1_text6"
    ]
  },
  {
    title: "c2_title",
    items: [
      "c2_text1",
      "c2_text2",
      "c2_text3",
      "c2_text4",
      "c2_text5",
      "c2_text6",
      "c2_text7",
      "c2_text8",
    ]
  },
  {
    title: "c3_title",
    items: [
      "c3_text1",
      "c3_text2",
      "c3_text3",
      "c3_text4",
      "c3_text5",
      "c3_text6"
    ]
  }, {
    title: "c4_title",
    items: []
  }, {
    title: "c5_title",
    items: []
  },
  {
    title: "c6_title",
    items: []
  }
];

export const accordionData = [
  { id: 'Wallet_Payment', label: 'Wallet Payment', content: 'True Walllet', imgUrl: 'https://play-lh.googleusercontent.com/6I2IYbIg4rhGUgs0UxP_5q6wmJmlBjBrlQ9f0_FAN94yOzwmrtEteifCdPPd1-chY_NX' },
  { id: 'Credit', label: 'Credit/Debit Card', content: 'กรุณาระบุข้อมูลบัตรเครดิต', imgUrl: 'https://www.tonysbeach.com/wp-content/uploads/2017/12/visa-mastercard.png' },
  { id: 'Mobile', label: 'Mobile Banking',imgUrl: 'https://cdn-icons-png.flaticon.com/512/4547/4547743.png', content: [
    { id: 1, label: 'Bangkok Bank',type: 'mobile_banking_bbl',imgUrl:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQXKyZ05p4coV96VdXaKzE_cPMdAurLdcxu3A&s"},
    { id: 2, label: 'K Plus',type: 'mobile_banking_kbank',imgUrl:'https://play-lh.googleusercontent.com/AyX675vwNz8X2sYUTSrjUTRVzzXMZUW_nMQ8Vk__Nabj6zQ7s7We-bpZbFmoYf7e2YM'},
    { id: 3, label: 'Krungthai Corporate',type: 'mobile_banking_ktb',imgUrl:"https://s3-symbol-logo.tradingview.com/krung-thai-bank--600.png"},
    { id: 4, label: 'SCB',type: 'mobile_banking_scb',imgUrl:'https://play-lh.googleusercontent.com/j-9a3HbVZoX337-MLdkmYt75yUfN5ahis8rOnE09972cFLdVn7Z5Dzu3Guo8ldUv2H4x'},
  ] },
]